export default function () {
  /**
    *
    * Init and set the params for the 2 different
    * carrousels on the product pages
    */
  if ($('.staff_carousel').length) {
      $('.staff_carousel').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
              }
          ]
      });
  }
  if ($('.testimonials_carousel').length) {
      $('.testimonials_carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000

      });
  }
}